module.exports = __webpack_public_path__ + "img/04.180bca5b.png";